import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import Modal from "@mui/material/Modal";
import GCTitleSticky from "./GCTitleSticky";

const GCEmployee = ({
  open,
  xCloseSearchModal,
  xTitle,
  xAnyData,
  xModelObj,
  xSearchEnter,
  xonChangeInputModal,
  xGridArr,
  xGridDataColumnsSearch,
  xRowClick,
  xRowCellClick,
  xClearSimpleSearch,
  xEnterObj,
  xMediaQuery = false,
}) => {
  return (
    <Modal
      open={open}
      onClose={xCloseSearchModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ overflow: "auto" }}
        className="model-sales-invoice-Employee-Modal"
      >
        <GCTitleSticky
        title={xTitle}
        onClose={xCloseSearchModal}
        />
      

        <div className="p-2">
          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 6, md: 12 }}
            className="align-items-center"
          >
            <Grid item xs={12} sm={12} md={5} className="wms-search-label">
              <Grid container spacing={2} columns={{ xs: 12, sm: 6, md: 12 }}>
                <Grid item xs={3} sm={2} md={3} className="wms-search-label">
                  Any Data
                </Grid>
                <Grid item xs={9} sm={4} md={9}>
                  <div className="input-group input-group-sm">
                    <input
                      autoComplete="off"
                      className="form-control form-control-sm"
                      id="GCEmployeeAnyData"
                      type="text"
                      name="AnyData"
                      value={xModelObj.AnyData}
                      onChange={xonChangeInputModal}
                      onKeyUp={xSearchEnter}
                    />
                    {xMediaQuery ? (
                      <span
                        className="input-group-text wms-salse-icon px-2"
                        onClick={(e) => xSearchEnter(xEnterObj)}
                      >
                        <ArrowForwardOutlinedIcon />
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </Grid>
                <Grid item xs={3} sm={2} md={3} className="wms-search-label">
                  First Name
                </Grid>
                <Grid
                  item
                  xs={9}
                  sm={4}
                  md={9}
                  className="input-group input-group-sm"
                >
                  <input
                    autoComplete="off"
                    className="form-control form-control-sm"
                    type="text"
                    name="FirstName"
                    value={xModelObj.FirstName}
                    onChange={xonChangeInputModal}
                    onKeyUp={xSearchEnter}
                  />
                  {xMediaQuery ? (
                    <span
                      className="input-group-text wms-salse-icon px-2"
                      onClick={(e) => xSearchEnter(xEnterObj)}
                    >
                      <ArrowForwardOutlinedIcon />
                    </span>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={5} className="wms-search-label">
              <Grid container spacing={2} columns={{ xs: 12, sm: 6, md: 12 }}>
                <Grid item xs={3} sm={2} md={3} className="wms-search-label">
                  Middle Name
                </Grid>
                <Grid
                  item
                  xs={9}
                  sm={4}
                  md={9}
                  className="input-group input-group-sm"
                >
                  <input
                    autoComplete="off"
                    className="form-control form-control-sm"
                    type="text"
                    name="MiddleName"
                    value={xModelObj.MiddleName}
                    onChange={xonChangeInputModal}
                    onKeyUp={xSearchEnter}
                  />
                  {xMediaQuery ? (
                    <span
                      className="input-group-text wms-salse-icon px-2"
                      onClick={(e) => xSearchEnter(xEnterObj)}
                    >
                      <ArrowForwardOutlinedIcon />
                    </span>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item xs={3} sm={2} md={3} className="wms-search-label">
                  Last Name
                </Grid>
                <Grid
                  item
                  xs={9}
                  sm={4}
                  md={9}
                  className="input-group input-group-sm"
                >
                  <input
                    autoComplete="off"
                    className="form-control form-control-sm"
                    type="text"
                    name="LastName"
                    value={xModelObj.LastName}
                    onChange={xonChangeInputModal}
                    onKeyUp={xSearchEnter}
                  />
                  {xMediaQuery ? (
                    <span
                      className="input-group-text wms-salse-icon px-2"
                      onClick={(e) => xSearchEnter(xEnterObj)}
                    >
                      <ArrowForwardOutlinedIcon />
                    </span>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={2} className="wms-search-label">
              <Grid container spacing={2} columns={{ xs: 12, sm: 6, md: 12 }}>
                <Grid item xs={6} sm={12} md={12}>
                  <button
                    className="btn btn-primary  search-btn"
                    onClick={xClearSimpleSearch}
                  >
                    Clear
                  </button>
                </Grid>
                <Grid item xs={6} sm={12} md={12}>
                  <button
                    className="btn btn-primary  search-btn"
                    onClick={(e) => {
                      xCloseSearchModal(e);
                      xClearSimpleSearch(e);
                    }}
                  >
                    Cancel
                  </button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={0} className="search-item ">
            <Grid
              item
              xs={12}
              className=" height-table-scroll mt-3"
              component="div"
            >
              <div
                style={{ height: xMediaQuery ? "44vh" : "60vh", width: "100%" }}
                id="table-main-grid-6"
                className="search-grid-table "
              >
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={xGridArr}
                  columns={xGridDataColumnsSearch}
                  hideFooter={xGridArr.length < 100}
                  onCellKeyDown={xRowCellClick}
                  onRowClick={xRowClick}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </Box>
    </Modal>
  );
};

export default GCEmployee;
